/* eslint-disable react-hooks/exhaustive-deps */
import useCustomLocation from "hooks/useCustomLocation";
import queryString from "querystring";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { scrollTop } from "../../utils/funciones";

const PrivateLayoutRoute = ({
  component: Component,
  layout: Layout,
  carritoVisible,
  ...rest
}) => {
  return (
    <Route {...rest}>
      <PrivateLayoutRoute2
        carritoVisible={carritoVisible}
        component={Component}
        layout={Layout}
      />
    </Route>
  );
};

const PrivateLayoutRoute2 = ({ component: Component, layout: Layout, ...rest }) => {
  const [loading, setLoading] = useState(false);

  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const { addToast } = useToasts();
  const history = useHistory();
  const params = useParams();

  const location = useCustomLocation();
  const qParams = queryString.parse(location.search);

  useEffect(() => {
    scrollTop();
    if (!dataUsuario || !dataUsuario.userIsLoggedIn) {
      history.push(`/login?goBackTo=${location.fullPathname}`);
    }
  }, []);

  return (
    <Layout>
      {dataUsuario.userIsLoggedIn && (
        <Component
          {...{
            loading,
            setLoading,
            dataUsuario,
            addToast,
            qParams,
            params,
            history,
          }}
        />
      )}
    </Layout>
  );
};

export default PrivateLayoutRoute;
